import React, { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppStylesProvider } from '../styles';
import { ReduxProvider } from './state';

type Props = PropsWithChildren<{
    baseName: string
}>;

export const AppProviders = ({
    children,
    baseName
}: Props) => {
    return (
        <BrowserRouter basename={baseName}>
            <ReduxProvider>
                <AppStylesProvider>
                    {children}
                </AppStylesProvider>
            </ReduxProvider>
        </BrowserRouter>
    );
};
